import classNames from "classnames";
import Close from "jsx:../../assets/svgs/close.svg";
import React from "react";
import { FormattedMessage } from "react-intl";

const ModalHeader = ({ logoSmallUrl, onClose, product_image }) => (
  <div className="modal-header">
    <div className="modal-product-img">
      <img src={product_image || logoSmallUrl} alt="img" />
    </div>
    <div className="modal-close">
      <Close className={classNames("close-icon-cart")} onClick={onClose} />
    </div>
    <div className="product-management">
      <FormattedMessage id="productManagement" />
    </div>
  </div>
);
export default ModalHeader;
